import { render, staticRenderFns } from "./TotalOrder.vue?vue&type=template&id=480ffe26&scoped=true&"
import script from "./TotalOrder.vue?vue&type=script&lang=js&"
export * from "./TotalOrder.vue?vue&type=script&lang=js&"
import style0 from "./TotalOrder.vue?vue&type=style&index=0&id=480ffe26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ffe26",
  null
  
)

export default component.exports